const getQueryParameters = (params) => params.split("&").map((str) => {
  const [key, val] = str.split("=");
  return {
    name: key,
    value: decodeURIComponent(val).replace(/\+/g, " ")
  };
});
export default getQueryParameters;
